/* @flow */

import * as React from "react";

import * as _ from "lodash";
import CountryUtil from "../../../uidispatcherapi/CountryUtil";
import MetroXAccountWrapper from "./accountFlyout/metroX/MetroXAccountWrapper";
import { isFsdShop } from "../../../utils/ShopFlavor";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import { IntlRootMixin } from "../../../IntlRootMixin";
import { SessionStore } from "../../../uidispatcherapi/SessionStore";
import { MetroXBrandBarEmployee } from "./MetroXBrandBarEmployee";
import { withReactAdapter } from "../../../module-federation/withReactAdapter";

// declare the web component for TypeScript
declare global {
    namespace JSX {
        interface IntrinsicElements {
            "cms-bucket-header-container": any;
        }
    }
}

export const MetroXBrandBar = createReactClass({
    mixins: [IntlRootMixin],

    propTypes: {
        forceFlyout: PropTypes.bool,
        history: PropTypes.object
    },

    componentDidMount() {
        if (SessionStore.isEmployee()) {
            return;
        }
        const siteCoreBaseUrl = _.get(
            CountryUtil.getOptionalConfig(),
            "siteCoreBaseUrl",
            "https://compaas-rev-sc.metro.de"
        );

        const scriptBrandbar = document.createElement("script");
        scriptBrandbar.src = `${siteCoreBaseUrl}/data/apps/metro?sc_device=webcomponent&components=bucket%20header%20container&bucketid=${
            isFsdShop() ? "delivery" : "mshop"
        }`;

        if (document.head) {
            document.head.appendChild(scriptBrandbar);
        }
    },

    render() {
        if (SessionStore.isEmployee()) {
            return <MetroXBrandBarEmployee history={this.props.history} />;
        }
        return (
            <div>
                <div className="metrox-brandbar">
                    <cms-bucket-header-container>
                        <div slot="account-switch" className={"account-switch"}>
                            <MetroXAccountWrapper
                                forceFlyout={this.props.forceFlyout || false}
                                history={this.props.history}
                            />
                        </div>
                    </cms-bucket-header-container>
                </div>
            </div>
        );
    }
});

export default withReactAdapter(MetroXBrandBar);
